"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Device = exports.HitType = exports.QueryFormFilterParam = exports.ApiError = void 0;
var ApiError_1 = require("./helpers/ApiError");
Object.defineProperty(exports, "ApiError", { enumerable: true, get: function () { return ApiError_1.ApiError; } });
__exportStar(require("./helpers/types"), exports);
var QueryFormFilterParam;
(function (QueryFormFilterParam) {
    QueryFormFilterParam["Transaction"] = "affiliation";
    QueryFormFilterParam["TransactionTax"] = "transactionTax";
    QueryFormFilterParam["TransactionShipping"] = "transactionShipping";
    QueryFormFilterParam["Browser"] = "browser";
    QueryFormFilterParam["Device"] = "device";
    QueryFormFilterParam["Loyalty"] = "isNewVisitor";
    QueryFormFilterParam["CustomVariableName"] = "customVarName";
    QueryFormFilterParam["CustomVariableValue"] = "customVarValue";
    QueryFormFilterParam["StartDate"] = "startDate";
    QueryFormFilterParam["EndDate"] = "endDate";
    QueryFormFilterParam["Country"] = "country";
    QueryFormFilterParam["Region"] = "region";
    QueryFormFilterParam["City"] = "city";
    QueryFormFilterParam["Page"] = "url";
    QueryFormFilterParam["EventCategory"] = "eventCategory";
    QueryFormFilterParam["EventAction"] = "eventAction";
    QueryFormFilterParam["EventLabel"] = "eventLabel";
    QueryFormFilterParam["SegmentKey"] = "segmentKey";
    QueryFormFilterParam["SegmentValue"] = "segmentValue";
    QueryFormFilterParam["HitType"] = "hitType";
    QueryFormFilterParam["ProductName"] = "productName";
    QueryFormFilterParam["ProductSKU"] = "productSku";
})(QueryFormFilterParam = exports.QueryFormFilterParam || (exports.QueryFormFilterParam = {}));
var HitType;
(function (HitType) {
    HitType["Segment"] = "SEGMENT";
    HitType["PageView"] = "PAGEVIEW";
    HitType["Event"] = "EVENT";
})(HitType = exports.HitType || (exports.HitType = {}));
var Device;
(function (Device) {
    Device["Desktop"] = "Desktop";
    Device["MobilePhone"] = "Mobile Phone";
    Device["Tablet"] = "Tablet";
})(Device = exports.Device || (exports.Device = {}));
//# sourceMappingURL=types.js.map